import React, { useRef, useState, useEffect } from 'react'
import './ContactSection.css'

const CONTACT_LINKS = [
  {
    icon: '✉',
    label: 'Email',
    value: 'quentin.ott2511@gmail.com',
    href: 'mailto:quentin.ott2511@gmail.com',
    color: '#00ff88',
  },
  {
    icon: '📞',
    label: 'Téléphone',
    value: '06 01 86 20 82',
    href: 'tel:0601862082',
    color: '#00aaff',
  },
  {
    icon: '💼',
    label: 'LinkedIn',
    value: 'linkedin.com/in/quentin-ott',
    href: 'https://linkedin.com/in/quentin-ott',
    color: '#a78bfa',
  },
  {
    icon: '⌥',
    label: 'GitHub',
    value: 'github.com/QuentinOtt',
    href: 'https://github.com/QuentinOtt',
    color: '#f59e0b',
  },
]

function useReveal(threshold = 0.1) {
  const ref = useRef(null)
  const [visible, setVisible] = useState(false)
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) { setVisible(true); obs.disconnect() }
    }, { threshold })
    if (ref.current) obs.observe(ref.current)
    return () => obs.disconnect()
  }, [threshold])
  return [ref, visible]
}

export default function ContactSection() {
  const [sectionRef, visible] = useReveal()
  const [copied, setCopied] = useState(false)

  const copyEmail = () => {
    navigator.clipboard.writeText('quentin.ott2511@gmail.com').then(() => {
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    })
  }

  return (
    <section id="contact" className="section contact-section" ref={sectionRef} aria-label="Contact">
      <div className={`section-inner contact-inner ${visible ? 'visible' : ''}`}>

        {/* Left */}
        <div className="contact-left">
          <div className="section-label"><span>06</span> Contact</div>
          <h2 className="section-title">
            Travaillons <span className="gradient-text">ensemble</span>
          </h2>
          <p className="contact-desc">
            Je suis activement à la recherche d'une <strong>alternance pour mon Master Expert Systèmes Connectés IA & IoT</strong> à l'ENSITECH (rythme 3 semaines entreprise / 1 semaine cours).
          </p>
          <p className="contact-desc">
            Disponible également pour des missions <strong>freelance</strong> en développement web, data ou IA.
          </p>

          {/* Big email button */}
          <div className="contact-email-block">
            <button className="contact-email-btn" onClick={copyEmail} aria-label="Copier l'email">
              <span className="contact-email-text">quentin.ott2511@gmail.com</span>
              <span className="contact-email-action">
                {copied ? (
                  <>
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                      <path d="M2 7l4 4 6-7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                    </svg>
                    Copié !
                  </>
                ) : (
                  <>
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                      <rect x="3" y="1" width="8" height="10" rx="1.5" stroke="currentColor" strokeWidth="1.2"/>
                      <rect x="1" y="3" width="8" height="10" rx="1.5" stroke="currentColor" strokeWidth="1.2" fill="var(--bg)"/>
                    </svg>
                    Copier
                  </>
                )}
              </span>
            </button>
          </div>

          {/* Alternance info */}
          <div className="contact-alternance glass-card">
            <div className="alternance-header">
              <span className="dot-pulse" />
              <span className="alternance-title">Recherche d'alternance active</span>
            </div>
            <div className="alternance-details">
              <div className="alternance-row">
                <span className="alternance-icon">📅</span>
                <span>Disponible dès <strong>2026</strong></span>
              </div>
              <div className="alternance-row">
                <span className="alternance-icon">🔄</span>
                <span>Rythme : <strong>3 semaines entreprise / 1 semaine cours</strong></span>
              </div>
              <div className="alternance-row">
                <span className="alternance-icon">🎓</span>
                <span>Formation : <strong>Master Expert Systèmes Connectés IA & IoT</strong></span>
              </div>
              <div className="alternance-row">
                <span className="alternance-icon">📍</span>
                <span>Mobilité : <strong>Île-de-France & remote</strong></span>
              </div>
            </div>
          </div>
        </div>

        {/* Right */}
        <div className="contact-right">
          {CONTACT_LINKS.map((link, i) => (
            <a
              key={link.label}
              href={link.href}
              target={link.href.startsWith('http') ? '_blank' : undefined}
              rel={link.href.startsWith('http') ? 'noopener noreferrer' : undefined}
              className="contact-link-card glass-card"
              style={{ '--link-color': link.color, '--delay': `${i * 80}ms` }}
            >
              <div className="contact-link-icon" style={{ color: link.color }}>
                {link.icon}
              </div>
              <div className="contact-link-info">
                <span className="contact-link-label">{link.label}</span>
                <span className="contact-link-value">{link.value}</span>
              </div>
              <div className="contact-link-arrow">→</div>
            </a>
          ))}

          {/* CV download */}
          <a
            href="/CV_Quentin_Ott.pdf"
            download
            className="contact-cv-btn btn-primary"
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M8 2v9M5 8l3 3 3-3M3 13h10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
            </svg>
            Télécharger mon CV complet
          </a>
        </div>
      </div>
    </section>
  )
}
